module.exports = __webpack_public_path__ + "static/media/card2.c1330029.png";